export const region_mapping = {'TM':'屯門','TSW':'天水圍'};

export const rootlink = window.debug1?'/mw_v2/search_test/':'/mw_v2/search/';

export const API_PATH = "https://www.manyw.com/apps/data_source.php";

export const order_mapping_search = {
	'score desc,updatetime desc':'綜合排名',	   
	'updatetime desc':'更新日期 (新至舊)',
	'updatetime asc':'更新日期 (舊至新)',
	'price desc':'價錢/租金 (高至低)',
	'price asc':'價錢/租金 (低至高)',	
	'net desc':'實用面積 (大至小)',
	'net asc':'實用面積 (小至大)',
};

export const order_mapping_bldg = {
	'cur_avg asc':'平均呎價 (低至高)',
	'cur_avg desc':'平均呎價 (高至低)',
	'cur_qty asc':'宗數 (低至高)',
	'cur_qty desc':'宗數 (高至低)',
}

export const order_mapping_tran = {
	'date desc':'成交日期 (新至舊)',
	'date asc':'成交日期 (舊至新)',
	'price desc':'成交價 (高至低)',
	'price asc':'成交價 (低至高)',	
	'net desc':'實用面積 (大至小)',
	'net asc':'實用面積 (小至大)',
}

export const room_mapping = {0:'開放式',1:'一房',2:'兩房',3:'三房',4:'四房'};
export const floor_mapping = {"high":'高層','middle':'中層','low':'低層'};
export const age_mapping = {"v_00_05"  :'五年內　　　　',
							'v_05_10'  :'五年至十年　　',
							'v_10_20'  :'十年至二十年　',
							'v_20_30'  :'二十年至三十年',
							'v_30_40'  :'三十年至四十年',
							'v_40_90'  :'四十年或以上　'
							};

export const seaview_mapping = {"half"  :'半海景',
								'full'  :'全海景',
								};

export const facility_mapping = {'sell_roof'  :'連天台',
								'sell_floor'  :'連平台',
								'balcony'  :'連露台',
								'garden'  :'連花園',
								'carpark'  :'連車位',
								};

export const plates = [
			//{name:'plate_gq3r',label:'優質三房',buyrent:["buy"],category:['private']},
			//{name:'plate_gqcar',label:'優質上車',buyrent:["buy"],category:['private']},
			//{name:'plate_price_eff_3r',label:'平價三房',buyrent:["buy"],category:['private','hos']},			
			//{name:'plate_low_downpayment',label:'低首期上車',buyrent:["buy"],category:['private','hos']},
			{name:'plate_new',label:'半新樓',buyrent:["buy","rent"],category:['private',"hos","white"],desc:'樓齡10年以下'},
			{name:'plate_south',label:'南延線',buyrent:['buy',"rent"],category:['private','hos','white'],desc:'港鐵屯門站向南延伸至屯門碼頭附近的屋苑'},
			{name:'plate_railway',label:'鐵路盤',buyrent:["buy",'rent'],category:['private','hos'],desc:'鄰近港鐵鐵路站的屋苑'},
			{name:'plate_90',label:'低首期精選',buyrent:['buy'],category:['private'],desc:'1000萬以內'},		 // price < 1000萬	
			{name:'plate_100',label:'100元釐印費',buyrent:['buy'],category:['private','hos','white'],desc:'300萬以下'},     // price < 300萬
			{name:'plate_400600',label:'慳稅之選',buyrent:['buy'],category:['private','hos','white'],desc:'400至600萬'},      // price 400-600
			];
			
export const menu_mapping = {
						"buyrent":{label:'租買',mobile:true,category:['private','hos','white','tran','shop']},
						"region":{label:'地區',mobile:true,category:['private','hos','white','bldg','tran','branch','shop']},
						"bldg":{label:'屋苑',mobile:true,category:['private','hos','white','bldg','tran','shop']},
						"pricerent":{label:'價錢',mobile:true,category:['private','hos','white','tran','shop']},
						'net':{label:'呎數',mobile:true,category:['private','hos','white','tran']},
						'room':{label:'房數',mobile:true,category:['private','hos','white']},
						'floor':{label:'層數',mobile:true,category:['private','hos','white','tran']},	
						// 'seaview':{label:'seaview',mobile:true,category:['private','hos','white']},	
						// 'facility':{label:'facility',mobile:true,category:['private','hos','white']},					
						'age':{label:'age',mobile:true,category:['private','hos','white']},
						'pet':{label:'pet',mobile:true,category:['private','hos','white']},						
						'v720':{label:'720',mobile:true,category:['private','hos','white']},
						//'white':{label:'white',mobile:true,category:['hos']}
						};
				
export const category_mapping = {
						"private":{label:'私樓',fav:true,need_placeholder:false},
						"hos":{label:'公居屋',fav:true,need_placeholder:false},
						"white":{label:'白居二',fav:true,need_placeholder:false},
						"shop":{label:'舖位',fav:true,need_placeholder:false},
						"tran":{label:'成交',fav:false,need_placeholder:false},
						'bldg':{label:'屋苑',fav:true,need_placeholder:true},							
						'branch':{label:'分行',fav:true,need_placeholder:true},											
						};			

export const blue = '#3591ea';
export const brown = '#873e23';

export const URL_MW = "https://www.manyw.com/";
export const thumbnailConfig = {width:350,height:225};  //{width:320,height:180};
export const imgConfig = {width:640,height:400};
export const default_config = {
	region:[],
	zone:[],
	bldg:[],
	price_hidden:{from:0,to:2000}, //this is for <Label> and Label color 
	price:{from:0,to:2000},
	rent:{from:0,to:30000},
	plate:[],
	//order:"score desc,updatetime desc",
	order:"",
	net:{from:0,to:2000},
	room:[],
	floor:[],
	price_type:'free',
	buyrent:'buy',
	v720:false,
	pet:false,
	age:[],
	white:false,
	seaview:[],
	facility:[],
	cancel_bldg:[],
};

export const default_searchresult = JSON.parse('{"result":true,"data":[{"prop_id":"xx","pro_no":"","c_name":"　　　　","room_valid":"show","dist":"　　","floor":"","madaam":"no","carpark":"","garden":"","sell_roof":"","sell_floor":"","bldg":"XX","remarks":"","recommend_by":"","photo_list_720":[],"monthFee":"","sales_lic":"","sales_phone":"","sales_cname":"","slogan":"","details1":"","details2":"","extra":"","ename":"","img_bk":"","matterport_link":"","matterport_remark":"","youtube":"","sole":false,"img":"","img2":"","net":"0","size":"0","room":"0","monthly":0,"price":0,"address":"","blk_qty":"","floor_info":"","carpark_info":"","unit_qty":"","developer":"","date_in":"","formation2":"","latitude":"22","longitude":"113","price_hos":"","price_rent":"","update_time":"","housing_image_list":[{"filename":""},{"filename":""},{"filename":""},{"filename":""}],"ratio":"","unit_rent_net":"","unit_rent_gross":"","unit_price_net":"","unit_price_gross":"","unit_hos_net":"","unit_hos_gross":"","branch_info":[{"tel":"","c_name":""},{"tel":"","c_name":""}],"images":null,"photo_list":[{"pro_no":"XXXX","file_name":"","type":"","owner_provide":""}]}]}');
for (var i=1;i<=12;i++){
	let t = JSON.parse(JSON.stringify(default_searchresult['data'][0]));
	t['prop_id'] = 'xx'+i;
	default_searchresult['data'].push(t);
}

export const default_bldgrs = JSON.parse('{"data":[{"auto_no":1,"name1":"　　　　　　　","address":"　　　　　　　","bldgcode":"","dist":"TM","img":"","cur_qty":null,"prev_qty":null,"cur_avg":0,"prev_avg":0,"ordering":0}]}');
for (var i=1;i<=12;i++){
	let t = JSON.parse(JSON.stringify(default_bldgrs['data'][0]));
	t['bldgcode'] = 'xx'+i;
	default_bldgrs['data'].push(t);
}

export const default_branchrs = JSON.parse('{"data":[{"category":"branch","name":"　　　　","bldgcode":"","phone":"        ","fax":"        ","address":"　　　　　　　　","coverImage":"","longitude":"113.977352","latitude":"22.390711","license":"          "}]}');
for (var i=1;i<=12;i++){
	let t = JSON.parse(JSON.stringify(default_branchrs['data'][0]));
	t['bldgcode'] = 'xx'+i;
	default_branchrs['data'].push(t);
}

export const default_tranrs = JSON.parse('{"data":[{"auto_no":"","bldgcode":"","mw_tran":false,"date":"　　　　　","cname":"　　　　　","blk":"　","floor":"　","flat":"　","net":"　","gfa":"　","bayWin":"-","price":"　","netunitPrice":"　　　","gfaunitPrice":"　　　"}]}');
for (var i=1;i<=12;i++){
	let t = JSON.parse(JSON.stringify(default_tranrs['data'][0]));
	t['auto_no'] = i;
	default_tranrs['data'].push(t);
}

export const iphonechrome = /(iPhone).*CriOS/.test(navigator.userAgent);

export const railway = ['TYC','TSHC','PYC','KV1','CGW','TPV','SHOC','PLV','NPV','KWG','TMTP','TP','HLG','EC','COR','CHG','PVC',"TG1","TG2"];

export const south = ['SHC' ,'MG' ,'SSC' ,'STMC' ,'MBT' ,'TOG' ,'MLG' ,'PG' ,'RG' ,'YWV','HFG' ,'SLC' ,'TNG' ,'RGB' ,'GG' ,'TSC' ,'OCH' ,'NC'  ];


export const thumbnailToImg = (x) => {
	x = x.replace('width='+thumbnailConfig.width, 'width='+imgConfig.width);
	x = x.replace('height='+thumbnailConfig.height, 'height='+imgConfig.height);
	return x;
}

export const tuneURL = (key1) => {
	if (key1){
		const url = new URL(window.location);		
		url.searchParams.set('q', key1);	
		url.searchParams.delete('bldgcode');	
		url.searchParams.delete('plate');	
		url.searchParams.delete('br');	
		window.history.pushState({}, '', url);		
	}
}

export const barminmax = (plate , type) => {
	switch( type ) {
		
		case "min":
			if (plate.indexOf('plate_90')!=-1){
				return 0;
			}
			if (plate.indexOf('plate_100')!=-1){
				return 0;
			}
			if (plate.indexOf('plate_400600')!=-1){
				return 4;
			}
			return 0;
		break;
		
		case "max":
			if (plate.indexOf('plate_90')!=-1){
				return 10;
			}
			if (plate.indexOf('plate_100')!=-1){
				return 3;
			}
			if (plate.indexOf('plate_400600')!=-1){
				return 6;
			}			
			return 20;
			
		break;
	}	
}

